import React from 'react';
import {useTranslation} from 'react-i18next';

import Icon from 'components/Icon';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Stack from 'components/Stack';

import SimpleModal from 'components/SimpleModal';

import {useDeletePlaylistContent} from 'actions/playlists';

function SectionDeleteConfirmation({playlistId, section, onClose}) {
	const {t} = useTranslation();

	const {deletePlaylistContent: deleteSection, isLoading} =
		useDeletePlaylistContent(playlistId, {
			successMessage: t('alert_section_deleted_successfully'),
			errorMessage: t('alert_section_not_deleted'),
		});

	function confirmDeletion() {
		deleteSection(section.id, {onSuccess: onClose});
	}

	return (
		<SimpleModal
			title={t('actions_delete_section')}
			body={
				<Stack spacing="s">
					{t('modal_confirm_delete_section')}
					<Flex>
						<Icon name="section" />
						<Text bold ml="xs" overflow="wrap">
							{section.name}
						</Text>
					</Flex>
				</Stack>
			}
			buttons={[
				{
					label: t('actions_keep'),
					onClick: onClose,
					isDisabled: isLoading,
				},
				{
					label: t('actions_delete'),
					onClick: confirmDeletion,
					isDisabled: isLoading,
					variant: 'primary',
				},
			]}
			onClose={onClose}
		/>
	);
}

export default SectionDeleteConfirmation;
